import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import type { MenuItemProps } from "@rg/ui/components/MenuItem";

export const useActiveMenu = (link?: string, subNav?: MenuItemProps[]) => {
  const location = useLocation();

  const isRouteActive = useMemo(() => {
    return link ? location.pathname.includes(link) : false;
  }, [link, location.pathname]);

  const hasActiveSubNav = useMemo(() => {
    return subNav?.some(
      (navItem) => navItem.link && location.pathname.includes(navItem.link)
    ) || false;
  }, [subNav, location.pathname]);

  return { isRouteActive, hasActiveSubNav };
};
